import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./typography.module.scss";

function P({size, children, className}) {
  return (
    <p className={classNames(styles[`${size}P`], className)}>{children}</p>
  );
}

P.defaultProps = {
  size: `main`
};

P.propTypes = {
  size: PropTypes.oneOf([`large`, `main`, `small`]),
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  className: PropTypes.string
};

export default P;
